export default __webpack_public_path__ + "static/media/44_BottomRightSquares_RotateLeft.387822c3.mp4";